<template>
  <div>
    <b-overlay
      :show="show"
      rounded="sm"
    >
      <template #overlay>
        <div class="text-center">
          <b-spinner
            variant="primary"
            style="width: 3rem; height: 3rem"
          />
          <p class="mt-2 mb-0">
            Cargando…
          </p>
        </div>
      </template>
      <div class="d-flex flex-wrap contract-actions-buttons">
        <b-button
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="primary"
          @click="openCheckoutModal"
        >
          Pagar
        </b-button>
        <!--
          Oculto para el invitado que entró por la app de un integrador: su
          sesión no tiene permiso sobre 'home', así que el botón lo mandaría a
          una pantalla de no autorizado. Su vuelta atrás es cerrar la ventana.
        -->
        <b-button
          v-if="!isGuestSession"
          v-ripple.400="'rgba(255, 255, 255, 0.15)'"
          variant="outline-secondary"
          @click="
            $router.push({
              name: 'home',
            })
          "
        >
          Volver al portal
        </b-button>
      </div>
    </b-overlay>

    <b-modal
      id="modal-checkout-actions"
      ref="modal-checkout-actions"
      content-class="shadow"
      ok-only
      centered
      ok-variant="outline-secondary"
      ok-title="Cerrar"
      no-close-on-backdrop
      size="lg"
      title="Pago"
    >
      <checkout
        :contract="data"
        :idcontrato="data.idcontrato"
      />
    </b-modal>
  </div>
</template>

<script>
import ToastificationContent from "@core/components/toastification/ToastificationContent.vue"
import { BButton, BOverlay, BSpinner } from "bootstrap-vue"
import Ripple from "vue-ripple-directive"
import Checkout from "@/views/home/Checkout.vue"
import { isGuestSession } from "@/auth/guestSession"

export default {
  directives: {
    Ripple,
  },
  components: {
    BButton,
    BOverlay,
    BSpinner,
    Checkout,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      show: true,
    }
  },
  computed: {
    isGuestSession() {
      return isGuestSession()
    },
  },
  created() {
    if (typeof this.data !== "undefined") {
      this.show = false
    }
  },
  mounted() {
    // ?pay=1 lo agrega el backend al emitir un enlace SSO: quien llega por la
    // app de un integrador tocó "Pagar", así que cae con el checkout ya abierto
    // en vez de tener que buscar el botón.
    if (this.$route.query.pay === "1") {
      this.$nextTick(() => this.openCheckoutModal())
    }
  },
  methods: {
    openCheckoutModal() {
      this.$bvModal.show("modal-checkout-actions")
    },
    showToast(message, variant, icon) {
      this.$toast({
        component: ToastificationContent,
        props: {
          title: message,
          variant,
          icon,
        },
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.contract-actions-buttons {
    gap: 0.625rem;
}
</style>
